<template>
  <div class="lang-switch">
    <button
      v-for="opt in options"
      :key="opt.value"
      type="button"
      class="lang-switch__btn"
      :class="{ 'is-active': current === opt.value }"
      @click="switchTo(opt.value)"
    >{{ opt.label }}</button>
  </div>
</template>

<script>
import { setLocale, SUPPORTED_LOCALES } from '@/main'

export default {
  name: 'SwitchLocaleComponent',
  data() {
    return {
      // По ТЗ 03.09.2026: казахский — основной, первый в переключателе.
      options: [
        { value: 'kz', label: 'ҚАЗ' },
        { value: 'ru', label: 'РУС' },
      ],
    }
  },
  computed: {
    current() { return this.$i18n.locale },
  },
  methods: {
    switchTo(locale) {
      if (!SUPPORTED_LOCALES.includes(locale)) return
      setLocale(locale)
    },
  },
}
</script>

<style scoped>
.lang-switch {
  display: inline-flex;
  gap: 4px;
  padding: 4px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.2);
}
.lang-switch__btn {
  padding: 6px 14px;
  border: 0;
  background: transparent;
  color: rgba(255, 255, 255, 0.7);
  font-weight: 600;
  font-size: 13px;
  border-radius: 6px;
  cursor: pointer;
  transition: background 0.15s, color 0.15s;
  font-family: inherit;
}
.lang-switch__btn:hover {
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
}
.lang-switch__btn.is-active {
  background: #fff;
  color: #111827;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);
}
</style>
